import { useState, useEffect } from 'react';

export type ViewMode = 'grid' | 'list';

/**
 * Custom hook to manage persistent view mode preference
 * Stores the user's preference in localStorage and applies it across all pages
 */
export const useViewMode = (defaultMode: ViewMode = 'grid'): [ViewMode, (mode: ViewMode) => void] => {
  const [viewMode, setViewModeState] = useState<ViewMode>(() => {
    // Try to load saved preference from localStorage
    try {
      const saved = localStorage.getItem('viewMode');
      if (saved === 'grid' || saved === 'list') {
        return saved as ViewMode;
      }
    } catch (error) {
      // If localStorage is not available, fall back to default
      console.warn('localStorage not available:', error);
    }
    return defaultMode;
  });

  const setViewMode = (mode: ViewMode) => {
    setViewModeState(mode);
    
    // Save preference to localStorage
    try {
      localStorage.setItem('viewMode', mode);
    } catch (error) {
      // If localStorage is not available, just continue without saving
      console.warn('Could not save view mode preference:', error);
    }
  };

  return [viewMode, setViewMode];
};
